// extracted by mini-css-extract-plugin
module.exports = {"render":"FLNAM_render__11oQO","currentPageButton":"FLNAM_currentPageButton__QmDrU","nextPageButton":"FLNAM_nextPageButton__1Fwzk"};